import request from "@/utils/request";
import {IDeliveryNoteStorageLayerModel} from "@/api/types";

export const defaultDeliveryNoteStorageLayerData: IDeliveryNoteStorageLayerModel = {
    id: null,
    //预计在仓时间开始
    estimatedInStorageDateStart: null,
    //预计在仓时间结束
    estimatedInStorageDateEnd: null,
    //预计下次发货时间
    estimatedNextDeliveryDate: null,
    //备注
    remark: null,
};

export const getDeliveryNote = (params,data: any) =>
    request({
        url: "/storages/inventory",
        method: "post",
        params,
        data
    });

export const getStorages = () =>
    request({
        url: "/storages",
        method: "get"
    });

export const editInformation = (id: string, data: any) =>
    request({
        url: `/delivery-note/${id}`,
        method: "put",
        data
    });

